<script>
export const group = 'Full'
</script>

<script setup>
import Transition4 from './transitions/Transition4.vue'
import TextSlideUpFade from './text_animations/TextSlideUpFade.vue'
import StopwatchPill from './shared/StopwatchPill.vue'
import JOEBackground1 from '../../../assets/animations/joe/backgrounds/joe_background_1.webm'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const timelineTitleAbove = ref(null)
const timelinePill = ref(null)
const timelineTitleBelow = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Stopwatch', delay: frames(40, 50) })
    .add(timelineTitleAbove)
    .add(timelinePill, `<${frames(16)}`)
    .add(timelineTitleBelow, `<${frames(2)}`)
})

const backgroundVideo = computed(() => item.properties?.backgroundVideo || JOEBackground1)
</script>

<template>
  <Transition4>
    <VideoPlayer :src="backgroundVideo" class="absolute size-full object-cover" autoplay muted loop />
    <div class="absolute top-[540px] right-[716px] -translate-y-1/2 translate-x-1/2 flex flex-col items-center text-white text-6xl font-bold gap-6">
      <TextSlideUpFade :text="item.properties.titleAbove || ''" @timeline="timelineTitleAbove = $event" />
      <StopwatchPill class="text-7xl !h-28" :stopwatch="item.enrichment.stopwatch" :showDays="!item.properties.showDaysAsHours" @timeline="timelinePill = $event" />
      <TextSlideUpFade :text="item.properties.titleBelow || ''" @timeline="timelineTitleBelow = $event" />
    </div>
  </Transition4>
</template>
